import React from 'react';
import { useMedia } from 'tamagui';

import CobuButton from '../atoms/CobuButton';
import CobuSpacer from '../atoms/CobuSpacer';
import CobuStack from '../layout/CobuStack';
import { DSSpacing, DSButtonVariant } from '../types';

interface ActionButton {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  title: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
}

interface CobuActionButtonsProps {
  buttons: ActionButton[];
  direction?: 'horizontal' | 'vertical';
  responsive?: boolean;
  gap?: DSSpacing;
}

const CobuActionButtons: React.FC<CobuActionButtonsProps> = ({
  buttons,
  direction = 'horizontal',
  responsive = true,
  gap = '$2',
}) => {
  const media = useMedia();

  // Switch to vertical on small screens if responsive
  const finalDirection = responsive && !media.gtXs ? 'vertical' : direction;

  return (
    <CobuStack
      layout={finalDirection}
      gap={gap}
      w="100%"
      jc="space-between"
    >
      {buttons.map((button, index) => (
        <React.Fragment key={index}>
          <CobuButton
            dsVariant={button.variant as DSButtonVariant}
            title={button.title}
            onPress={button.onPress}
            disabled={button.disabled}
            loading={button.loading}
            f={1}
          
          />
          {/* Add spacer between buttons in vertical mode on small screens */}
          {finalDirection === 'vertical' && index < buttons.length - 1 && !media.gtXs && (
            <CobuSpacer size="$3" />
          )}
        </React.Fragment>
      ))}
    </CobuStack>
  );
};

export default CobuActionButtons; 